import { Controller } from "@hotwired/stimulus"

// The flow chart's zoom buttons: the chart is scaled with CSS zoom (so the page scrolls to its real size), one step at a time,
// and "fit" puts it back to full size.
export default class extends Controller {
    static targets = ["stage"]

    connect() {
        this.level = 1
    }

    zoomIn() {
        this.apply(this.level + 0.1)
    }

    zoomOut() {
        this.apply(this.level - 0.1)
    }

    fit() {
        this.apply(1)
    }

    apply(level) {
        this.level = Math.min(1.5, Math.max(0.5, Math.round(level * 10) / 10))
        this.stageTarget.style.zoom = this.level
    }
}
